<template>
  <GalleryDesktopThumbnail :aria-label :is-active @select="emit('select')">
    <slot name="default" />
  </GalleryDesktopThumbnail>
</template>

<script setup lang="ts">
import GalleryDesktopThumbnail from '../GalleryDesktopThumbnail/GalleryDesktopThumbnail.vue'

withDefaults(
  defineProps<{
    isActive?: boolean
    ariaLabel?: string
  }>(),
  {
    isActive: false,
    ariaLabel: undefined,
  },
)

const emit = defineEmits<{
  (e: 'select'): void
}>()
</script>
